import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/customer/billing/customer.billing.query.gql"
import type {
  CustomerBillingQuery,
  CustomerBillingQueryVariables,
} from "@/v2-backoffice-client/customer/billing/__types__/customer.billing.query"

type Options = QueryHookOptions<
  CustomerBillingQuery,
  CustomerBillingQueryVariables
>

// The customer panel's Billing tab in one round trip: the Fenerum account row
// (null when not linked) and the invoice history behind it. The view sheet
// runs the same query (same variables) for the tab badge, so the two share
// one cache entry.
export function useCustomerBillingQuery(options?: Options) {
  return useQuery<CustomerBillingQuery, CustomerBillingQueryVariables>(
    query,
    options,
  )
}
